export default __webpack_public_path__ + "static/media/ke4_official.47962304.png";